import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { MyaccountEmployeeAddressComponent } from './myaccount-employee-address.component';

@NgModule({
  declarations: [MyaccountEmployeeAddressComponent],
  exports: [MyaccountEmployeeAddressComponent],
  imports: [
    CommonModule,
    I18nModule,
    MatCheckboxModule,
    ConfigModule.withConfig({
      cmsComponents: {
        EditEmployeeComponent: {
          component: MyaccountEmployeeAddressComponent,
        },
      },
    } as CmsConfig),
  ],
})
export class MyaccountEmployeeAddressModule {}
